<div
  class="header-container d-flex justify-content-between align-items-center p-2 header-bottom-border"
  [class.header-container--with-back]="showCompactBack()"
  >

  <div class="cursor-pt logo-container" [routerLink]="homeRoute">
    <img [src]="themeService.image().presentationLogo" alt="Logo" height="74">
  </div>
  <div class="d-flex align-items-center">
    @if (showCompactBack()) {
      <button
        (click)="goBack(routeBackPage())"
        appButton
        variant="ghost"
        iconOnly
        motion="back"
        >
        <fa-icon
          class="border-secondary text-basic"
          style="font-size: 24px;"
          [icon]="icon.faArrowLeft"
          >
        </fa-icon>
      </button>
    }
    @if (currentPage()) {
      <div class="text-white cursos-label" [class.fs-2]="!isMobile()" [class.mx-2]="!isMobile()">
        {{currentPage()}}
      </div>
    }
  </div>




  <div class="icons-container">
    @if (showForumSearch() && hasSearch()) {
      <div class="search-container">
        <form [formGroup]="coursesForm" (ngSubmit)="search()" class="d-flex">
          <div style="display: flex; align-items: center;">
            <svg class="search-icon cursor-pt" (click)="toggleSearch()" width="30" height="30" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.7233 16.8365H17.7296L17.3774 16.4969C18.6101 15.0629 19.3522 13.2013 19.3522 11.1761C19.3522 6.66038 15.6918 3 11.1761 3C6.66038 3 3 6.66038 3 11.1761C3 15.6918 6.66038 19.3522 11.1761 19.3522C13.2013 19.3522 15.0629 18.6101 16.4969 17.3774L16.8365 17.7296V18.7233L23.1258 25L25 23.1258L18.7233 16.8365ZM11.1761 16.8365C8.04402 16.8365 5.51572 14.3082 5.51572 11.1761C5.51572 8.04402 8.04402 5.51572 11.1761 5.51572C14.3082 5.51572 16.8365 8.04402 16.8365 11.1761C16.8365 14.3082 14.3082 16.8365 11.1761 16.8365Z" class="icon-header"/>
            </svg>
            <input type="text" id="mobileSearchBox" formControlName="seeker" class="search-input text-medium" placeholder="{{ searchPlaceholderKey() | translate }}">
            <svg class="d-none close-icon cursor-pt icon-basic" alt="Cerrar" id="closeIcon" (click)="toggleSearch()" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.3007 0.709727C12.9107 0.319727 12.2807 0.319727 11.8907 0.709727L7.0007 5.58973L2.1107 0.699727C1.7207 0.309727 1.0907 0.309727 0.700703 0.699727C0.310703 1.08973 0.310703 1.71973 0.700703 2.10973L5.5907 6.99973L0.700703 11.8897C0.310703 12.2797 0.310703 12.9097 0.700703 13.2997C1.0907 13.6897 1.7207 13.6897 2.1107 13.2997L7.0007 8.40973L11.8907 13.2997C12.2807 13.6897 12.9107 13.6897 13.3007 13.2997C13.6907 12.9097 13.6907 12.2797 13.3007 11.8897L8.4107 6.99973L13.3007 2.10973C13.6807 1.72973 13.6807 1.08973 13.3007 0.709727Z" fill="white"/>
            </svg>
          </div>
        </form>
      </div>
    }
    <div class="d-none d-md-block">
      <app-notification-bell [bell]="showBell()"></app-notification-bell>
    </div>
    <app-mobile-secondary-menu></app-mobile-secondary-menu>
    <div class="profile-container d-flex align-items-center cursor-pt" routerLink="/settings">
      @if (loading) {
        <div class="header-avatar me-2" [ngxSkeleton]="true"></div>
      } @else {
        @if (avatar()) {
          <img
            appImageFallback
            [appImageFallbackSrc]="profileAvatarFallback"
            [src]="avatar()!"
            alt="Perfil"
            class="header-avatar me-2"
          >
        }
        @if (!avatar()) {
          <svg class="header-avatar me-2" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1334_36110)">
              <rect width="32" height="32" rx="16" class="empty-avatar-wheel"/>
              <rect x="10.2031" y="7.77148" width="11.1304" height="10.9714" rx="5.48571" class="internal-empty-avatar"/>
              <rect x="5.56641" y="20.5713" width="22.2609" height="21.9429" rx="10.9714" class="internal-empty-avatar"/>
            </g>
            <defs>
              <clipPath id="clip0_1334_36110">
                <rect width="32" height="32" rx="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        }
      }

      @if (loading) {
        <span
          class="bold-text text-basic"
          style="display: inline-block; width: 109px; border-radius: 4px"
          [ngxSkeleton]="true"
        >&nbsp;</span>
      } @else {
        <span class="bold-text text-basic">{{ name() }} {{ lastName() }}</span>
      }
    </div>
  </div>
</div>
